class Loan {

    constructor( {api, store}) {
        if (!api) {
            return new Error(`Missing backend api`);
        }
        if (!store) {
            return new Error(`Missing store`);
        }
        this.api = api;
        this.store = store;
    }

    getLoan() {
        var state = this.store.getState();
        return state.loan.loanJson;
    }

    getLoanId() {
        var loan = this.getLoan();
        return loan ? loan.loanId : null;
    }

    ////////////////
    ////// API /////
    ////////////////

    getLoanFromAPI(loanId) {
        return this.api.getLoan(loanId || this.getLoanId());
    }

    updateProvider(sourceItem) {
        return this.api.updateProvider(this.getLoanId(), sourceItem);
    }

    getDocument(documentId) {
        return this.api.getDocument(this.getLoanId(), documentId)
                .then((report) => this.validateBankReport(report));
    }

    getDocumentUrl(documentS3URI) {
        return this.api.getDocumentUrl(this.getLoanId(), documentS3URI)
                .then((response) => Promise.resolve(response.documentURL));
    }

    generateDownloadUrl(type, key, loanId) {
        return this.api.generateDownloadUrl(type, key, loanId)
                .then((response) => Promise.resolve(response.documentURL), (error) => Promise.reject(error));
    }

    generateUploadUrl(documentName, documentPurpose, documentType) {
        return this.api.generateLoanUploadUrl(documentName, documentPurpose, documentType, this.getLoanId());
    }

    uploadCallback(url, params){
        return this.api.uploadCallback(url, params);
    }

    verifyBankForManualIncome(verifiedBankSource) {
        return this.api.verifyBankForManualIncome(this.getLoanId(), verifiedBankSource);
    }

    removeVerifiedBankSource(verifiedBankSource) {
        return this.api.removeVerifiedBankSource(this.getLoanId(), verifiedBankSource);
    }

    ////////////////
    ///VALIDATION///
    ////////////////

    validateBankReport(report) {
        if (!Array.isArray(report)) {
            return Promise.reject(new Error(`Invalid report`));
        }
        return Promise.resolve(report);
    }

}

export default Loan;
